export class NavItem {
  constructor(
    public name: string,
    public link: string,
    public isBtn: boolean,
    public command?: (event?: any) => any
  ) {}
}
